export default __webpack_public_path__ + "locales/pt/Settings.json?hash=1e492280a824f672babf1e1af0858546";